export default __webpack_public_path__ + "static/media/img_logo_white.a829473c.svg";